import React, { SVGProps } from 'react';

export const CaretRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m16.5 12-7.05 7.006-1.26-1.276L13.904 12 8.19 6.27l1.26-1.276z"
    />
  </svg>
);
